<section class="assignment" data-testid="assignment-panel" aria-label="Who is dealing with this">
  <div class="assignment__row">
    <app-icon name="user" [size]="18" />
    @if (state(); as s) {
      <ng-template #current>
        @if (s.assignee; as person) {
          Dealt with by <strong>{{ person.name }}</strong>
        } @else {
          Nobody is dealing with this
        }
      </ng-template>
      <!-- The line itself moves it; without that right it opens the history, once there is any. -->
      @if (s.can_move) {
        <button
          type="button"
          class="assignment__current assignment__current--link"
          [class.assignment__nobody]="!s.assignee"
          matTooltip="Move to someone else"
          (click)="openMove()"
          data-testid="assignment-current"
        >
          <ng-container [ngTemplateOutlet]="current" />
        </button>
      } @else if (s.history.length) {
        <button
          type="button"
          class="assignment__current assignment__current--link"
          [class.assignment__nobody]="!s.assignee"
          (click)="openHistory()"
          data-testid="assignment-current"
        >
          <ng-container [ngTemplateOutlet]="current" />
        </button>
      } @else {
        <span
          class="assignment__current"
          [class.assignment__nobody]="!s.assignee"
          data-testid="assignment-current"
        >
          <ng-container [ngTemplateOutlet]="current" />
        </span>
      }
      <span class="assignment__actions">
        @if (!s.assignee) {
          <button
            mat-stroked-button
            type="button"
            [disabled]="taking()"
            (click)="take()"
            data-testid="assignment-take"
          >
            Deal with this
          </button>
        }
      </span>
    } @else if (loadFailed()) {
      <span class="assignment__nobody">Couldn't load who is dealing with this</span>
    } @else {
      <span class="assignment__nobody">Loading…</span>
    }
  </div>

  @if (error(); as message) {
    <div class="error-banner" role="alert">{{ message }}</div>
  }
</section>
